import React, { useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { showLogin } from './actions';
import Modal from 'scy/Modal';
import { LightBackground } from 'scy/Background';
import LoginWithVerification from './loginWithVerification';
import ForgotHeader from './forgotHeader';
import SignupFooter from './signupFooter';
import LoginFooter from './loginFooter';
import ForgotForm from './forgot';
import SignupWithPromo from './signupWithPromo';
import { formBackground } from 'components/authPages/styles.mod.scss';
import styles from './styles.mod.scss';

function AuthModal({ showLogin, display, user }) {
  const [canClose, setCanClose] = useState(true);

  const showLoginView = () => showLogin('login');
  const showForgot = () => showLogin('forgot');
  const showSignup = () => showLogin('signup');
  const closeModal = () => showLogin(false);

  // HACKY: If signing up on gifting page, reload to get server-generated shopper token
  const reloadOnSignup =
    typeof window !== 'undefined' && window.location.pathname === '/gifting';

  return (
    <Modal
      className={styles.modalContent}
      isOpen={!!display}
      handleClose={closeModal}
      canClose={canClose}
    >
      <LightBackground className={formBackground}>
        <div className={styles.formContainer}>
          {display === 'signup' && (
            <>
              <SignupWithPromo
                compact
                reloadOnSignup={reloadOnSignup}
                shopNow={closeModal}
                onVerifyMobile={() => setCanClose(false)}
                onPostSignup={() => setCanClose(true)}
              />

              {_.isEmpty(user) && <LoginFooter showLogin={showLoginView} />}
            </>
          )}

          {display === 'login' && (
            <LoginWithVerification
              showForgot={showForgot}
              showSignup={showSignup}
              onSuccess={() => {
                if (reloadOnSignup) {
                  window.location.reload();
                } else {
                  setCanClose(true);
                  closeModal();
                }
              }}
            />
          )}

          {display === 'forgot' && (
            <>
              <ForgotHeader />
              <ForgotForm showLogin={showLoginView} />
              <SignupFooter showSignup={showSignup} />
            </>
          )}
        </div>
      </LightBackground>
    </Modal>
  );
}

const ConnectedAuthModal = connect(
  state => ({ display: state.login.display, user: state.login.user }),
  { showLogin }
)(AuthModal);

export default ConnectedAuthModal;
